import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  RemoveTagsFromEntityMutation,
  RemoveTagsFromEntityMutationVariables,
} from '@/gql/graphql';

const RemoveTagsFromEntity = graphql(`
  mutation RemoveTagsFromEntity($input: RemoveTagsFromEntityInput!) {
    removeTagsFromEntity(input: $input) {
      ... on Project {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on ScheduledEvent {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Customer {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Material {
        id
        tags {
          id
          colour
          name
        }
      }
      ... on Supplier {
        id
        tags {
          id
          colour
          name
        }
      }
    }
  }
`);

const useRemoveTagsFromEntity = (
  options?: UseMutationOptions<
    RemoveTagsFromEntityMutation,
    unknown,
    RemoveTagsFromEntityMutationVariables['input']
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(RemoveTagsFromEntity, { input });
    },
    ...options,
  });
};

export default useRemoveTagsFromEntity;
